export default "__VITE_ASSET__Cqw$lgmJ__"